import { siteInfo } from '@/mocks/comics';
import { useState } from 'react';
import { testimonials } from '@/mocks/comics';

export default function Testimonials() {
  const [current, setCurrent] = useState(0);
  const total = testimonials.length;

  const prev = () => setCurrent((c) => (c - 1 + total) % total);
  const next = () => setCurrent((c) => (c + 1) % total);

  const t = testimonials[current];

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <p className="text-center text-foreground-500 text-sm font-heading tracking-wider mb-8 md:mb-12">
          ( 漫友真实评价 )
        </p>

        <div className="relative bg-background-50 rounded-2xl p-8 md:p-12">
          <div className="absolute top-6 left-6 md:top-8 md:left-8 text-6xl md:text-7xl text-primary-200 font-serif leading-none select-none">
            &ldquo;
          </div>

          <div className="inline-flex items-center gap-1.5 bg-foreground-950 text-background-50 px-3 py-1.5 rounded-full text-sm font-semibold font-label mb-6">
            <i className="ri-star-fill text-amber-400 text-xs"></i>
            <span>{siteInfo.stats.avgRating}</span>
          </div>

          <blockquote className="text-foreground-800 text-base md:text-lg leading-relaxed font-heading mt-6">
            {t.comment}
          </blockquote>

          <div className="flex items-center gap-4 mt-8 pt-6 border-t border-background-200">
            <img
              src={t.avatar}
              alt={t.name}
              className="w-12 h-12 rounded-full object-cover"
              loading="lazy"
            />
            <div>
              <p className="text-foreground-900 font-semibold text-sm">{t.name}</p>
              <p className="text-foreground-500 text-xs">{t.date}</p>
            </div>
          </div>

          <div className="absolute bottom-6 md:bottom-8 right-6 md:right-8 flex gap-2">
            <button
              onClick={prev}
              className="w-10 h-10 flex items-center justify-center rounded-lg border border-background-300 text-foreground-600 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button
              onClick={next}
              className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}